import React, { useState } from "react";
import logo from "../assets/images/logo2.png";
import video from "../assets/images/video.png";
import talent from "../assets/images/talentt.png";
import { MdArrowOutward } from "react-icons/md";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

import CompanyForm from "./Company/Register";
import TalentLogin from "./Talent/Login";
import Login from "./Company/Login";
import decoration from "../assets/images/decoration.png";
import { useTranslation } from "react-i18next";

const JoinUs = () => {

  const [view, setView] = useState("main");
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <div className="inter-font layout-wrapper sofia-font">
      <Header />
      <div className=" left-strip" style={{ marginLeft: isRTL ? "0" : "1%", marginRight: isRTL ? "1%" : "0", padding: 0 }}>
        {[...Array(25)].map((_, i) => (
          <img
            key={i}
            src={decoration}
            alt="Decoration"
            className=" strip-icon"
          />
        ))}
      </div>
      {view === "main" && (
        <div
          className="inter-font sofia-font main-bg d-flex justify-content-center align-items-center flex-column"
          style={{ minHeight: "100vh", padding: "20px" }}
        >
          <div className="inter-font text-center mb-4">
            {/* <Link to={"/"}>
            <img
              src={logo}
              alt="Logo"
              style={{ maxWidth: "180px", width: "100%" }}
            />
            </Link> */}
            <h2
              className="inter-font fw-bold mt-3 inter-font"
              style={{ fontSize: "20px" }}
            >
              {t("join_title")}
            </h2>
          </div>

          <div
            className="inter-font container bg-white py-4 rounded-5"
            style={{
              maxWidth: "722px",
              width: "100%",
              boxShadow: "0px 0px 15px rgba(0,0,0,0.05)",
            }}
          >
            <div className="inter-font row">
              <div className="inter-font col-12 col-md-6 text-center company-border mt-4">
                <div className="inter-font company">
                  <img
                    src={video}
                    alt="Video"
                    // style={{ maxWidth: "120px", width: "100%", height: "auto" }}
                  />
                  <h4
                    className="inter-font mt-4 sofia-font company-font"
                    style={{ fontSize: "18px" }}
                  >
                    {t("join_com")}
                  </h4>
                  <p
                    className="inter-font fw-lighter mb-4 sofia-font company-font-para"
                    style={{
                      color: "rgba(146, 146, 146, 1)",
                      fontSize: "14px",
                    }}
                    >
                    {t("join_t_dec")}
                  </p>
                  <Link
                    className="inter-font btn btn-base sofia-font btns-for-signUp-SignIn w-lg-75"
                    to={'/company/login'}
                    style={{
                      padding: "10px 15px",
                    }}
                  >
                    {t("join_c_btn")}
                    <MdArrowOutward
                      fontSize={20}
                      style={{ marginLeft: "8px" }}
                    />
                  </Link>
                </div>
              </div>

              <div className="inter-font col-12 col-md-6 text-center mt-4">
                <div className="inter-font talent">
                  <img
                    src={talent}
                    alt="Talent"
                    // style={{ maxWidth: "120px", width: "100%", height: "auto" }}
                  />
                  <h4
                    className="inter-font mt-4 sofia-font talent-font"
                    style={{ fontSize: "18px" }}
                  >
                    {t("new_text_16")}
                  </h4>
                  <p
                    className="inter-font fw-lighter mb-4 sofia-font talent-font-para"
                    style={{
                      color: "rgba(146, 146, 146, 1)",
                      fontSize: "14px",
                    }}
                  >
                    {t("join_talent")}
                  </p>
                  <Link
                    className="inter-font btn btn-base btn-bg sofia-font btns-for-signUp-SignIn w-lg-75"
                    style={{
                      background: "#000",
                    }}
                    to={'/talent/register'}
                  >
                    {t("join_t_btn")}
                    <MdArrowOutward
                      fontSize={20}
                      style={{ marginLeft: "8px" }}
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {view === "company" && <Login />}
      {view === "talent" && <TalentLogin />}
      <Footer />
    </div>
  );

};

export default JoinUs;
